import React from "react";
import { DialogContent } from "@/components/ui/dialog";

function SizeGuide({ sizeGuide }) {
  return (
    <DialogContent
      className="flex flex-col px-[50px] py-[60px] max-h-[65%] xl:max-h-[80%] max-w-full lg:max-w-[80%] xl:max-w-[900px] w-[calc(92%-(((92%-60px)/2)-500px))]
      overflow-y-auto overflow-x-hidden"
    >
      <div
        className="flex flex-col"
        dangerouslySetInnerHTML={{
          __html: sizeGuide,
        }}
      ></div>
    </DialogContent>
  );
}

export default SizeGuide;
